import React from 'react';
import { Box } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';
import brandLogo from '@assets/brand_logo.svg';

export interface BrandMarkProps {
  /** Width & height of the square logo tile, in px. */
  size?: number;
  /** Corner radius of the tile, in px. */
  radius?: number;
  /** Extra styles merged onto the tile. */
  sx?: SxProps<Theme>;
}

/**
 * Vaidvana brand emblem, rendered as a rounded white "app-icon" tile.
 *
 * The source artwork (brand_logo.svg) has a white background baked in, so we
 * present it as a tile with a soft shadow — this reads cleanly on both light
 * surfaces (navbars, sidebar) and dark surfaces (login panel, footer) instead
 * of showing a bare white square.
 */
const BrandMark: React.FC<BrandMarkProps> = ({ size = 36, radius = 10, sx }) => (
  <Box
    component="img"
    src={brandLogo}
    alt="Vaidvana"
    sx={{
      width: size,
      height: size,
      borderRadius: `${radius}px`,
      bgcolor: 'common.white',
      objectFit: 'cover',
      boxShadow: '0 2px 8px rgba(15, 76, 58, 0.12)',
      flexShrink: 0,
      display: 'block',
      ...sx,
    }}
  />
);

export default BrandMark;
